<template>
  <ChipState
    :label="label"
    :isDense="isDense"
    textColor="#FFF"
    bgColor="#F45454"
    class="md:!tw-py-0 md:!tw-px-[.3rem]"
  >
    <template #prefix>
      <InfoIconWhite class="sm:!tw-w-[12px] sm:!tw-h-[12px]" />
    </template>
  </ChipState>
</template>
<script setup>
import ChipState from "@/core/components/common/ChipState";
import InfoIconWhite from "@/core/components/icons/InfoIconWhite";

const props = defineProps({
  label: {
    type: String,
    default: "Reject",
  },
  isDense: Boolean,
});
</script>
<script>
export default {
  name: "RejectChip",
};
</script>
